import {
    FETCH_DAILY_HYDRATION_DATA_REPORTS,
    FETCH_DAILY_HYDRATION_DATA_REPORTS_FETCHING,
    FETCH_DAILY_HYDRATION_DATA_REPORTS_SUCCESS,
    FETCH_DAILY_HYDRATION_DATA_REPORTS_FAIL,
    FETCH_WEEKLY_HYDRATION_DATA_REPORTS,
    FETCH_WEEKLY_HYDRATION_DATA_REPORTS_FETCHING,
    FETCH_WEEKLY_HYDRATION_DATA_REPORTS_SUCCESS,
    FETCH_WEEKLY_HYDRATION_DATA_REPORTS_FAIL
} from '../../actions/hydrationDataReportsActions';
import { RESET_PROFILE_PAGE } from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    dailyHydrationData: [],
    dailyHydrationDataFetching: false,
    dailyHydrationDataFetchFail: false,
    weeklyHydrationData: [],
    weeklyHydrationDataFetching: false,
    weeklyHydrationDataFetchFail: false
};

// ======= Daily Fetching Handlers =======
const fetchDailyHydrationDataFetching = (state) => {
    return {
        ...state,
        dailyHydrationDataFetching: true,
        dailyHydrationDataFetchFail: false
    };
};

const fetchDailyHydrationDataSuccess = (state, action) => {
    return {
        ...state,
        dailyHydrationData: action.dailyHydrationData,
        dailyHydrationDataFetching: false,
        dailyHydrationDataFetchFail: false
    };
};

const fetchDailyHydrationDataFail = (state) => {
    return {
        ...state,
        dailyHydrationDataFetching: false,
        dailyHydrationDataFetchFail: true
    };
};

// ======= Weekly Fetching Handlers =======
const fetchWeeklyHydrationDataFetching = (state) => {
    return {
        ...state,
        weeklyHydrationDataFetching: true,
        weeklyHydrationDataFetchFail: false
    };
};

const fetchWeeklyHydrationDataSuccess = (state, action) => {
    return {
        ...state,
        weeklyHydrationData: action.weeklyHydrationData,
        weeklyHydrationDataFetching: false,
        weeklyHydrationDataFetchFail: false
    };
};

const fetchWeeklyHydrationDataFail = (state) => {
    return {
        ...state,
        weeklyHydrationDataFetching: false,
        weeklyHydrationDataFetchFail: true
    };
};

const resetToInitialState = () => INITIAL_STATE;

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DAILY_HYDRATION_DATA_REPORTS_FETCHING]: fetchDailyHydrationDataFetching,
    [FETCH_DAILY_HYDRATION_DATA_REPORTS_SUCCESS]: fetchDailyHydrationDataSuccess,
    [FETCH_DAILY_HYDRATION_DATA_REPORTS_FAIL]: fetchDailyHydrationDataFail,
    [FETCH_WEEKLY_HYDRATION_DATA_REPORTS_FETCHING]: fetchWeeklyHydrationDataFetching,
    [FETCH_WEEKLY_HYDRATION_DATA_REPORTS_SUCCESS]: fetchWeeklyHydrationDataSuccess,
    [FETCH_WEEKLY_HYDRATION_DATA_REPORTS_FAIL]: fetchWeeklyHydrationDataFail,
    [RESET_PROFILE_PAGE]: resetToInitialState
};

// ======= Default Action ======
export default function hydrationDataReports(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDailyHydrationData(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_DAILY_HYDRATION_DATA_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchWeeklyHydrationData(payload, evictCache) {
    return {
        type: FETCH_WEEKLY_HYDRATION_DATA_REPORTS,
        payload: payload,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

// ======= Selectors =======
export const getDailyHydrationData = (state) => {
    return state.hydrationDataReports.dailyHydrationData ? state.hydrationDataReports.dailyHydrationData : null;
};

export const isDailyHydrationDataFetching = (state) => {
    return state.hydrationDataReports.dailyHydrationDataFetching;
};

export const didDailyHydrationDataFetchFail = (state) => {
    return state.hydrationDataReports.dailyHydrationDataFetchFail;
};

export const getWeeklyHydrationData = (state) => {
    return state.hydrationDataReports.weeklyHydrationData ? state.hydrationDataReports.weeklyHydrationData : null;
};

export const isWeeklyHydrationDataFetching = (state) => {
    return state.hydrationDataReports.weeklyHydrationDataFetching;
};

export const didWeeklyHydrationDataFetchFail = (state) => {
    return state.hydrationDataReports.weeklyHydrationDataFetchFail;
};
